import { handleErrors } from './ErrorActions';
import * as savedSearchesApi from '../api/saved-searches';

export const GET_SAVED_SEARCH_COLUMNS_SUCCESS = 'GET_SAVED_SEARCH_COLUMNS_SUCCESS';

export const getSavedSearchColumnsSuccess = (entityName, savedSearchName, columns) => ({
  type: GET_SAVED_SEARCH_COLUMNS_SUCCESS,
  entityName,
  savedSearchName,
  columns,
});

export const getSavedSearchColumns = (entityName, savedSearchName) => async (dispatch) => {
  try {
    const params = { entityName, searchName: savedSearchName };
    const apiData = await savedSearchesApi.getSavedSearchColumns(params);

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
    } else {
      dispatch(getSavedSearchColumnsSuccess(entityName, savedSearchName, apiData.columns));
    }
  } catch (error) {
    dispatch(handleErrors(error));
  }
};
